// @owners { team: patients-team }
import { Card, Column, LgPadding } from '@alto/design-system';
import { TransferForm, TransferHeader } from '@alto/features';
import React, { useEffect } from 'react';
import { getCompanyName } from '~shared/config/getCompanyName';
import getShowProgynySelfServiceForUser from '~shared/features/users/selectors/getShowProgynySelfServiceForUser';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { ORIGIN_NAMES } from '~shared/lib/analytics/src/getOrigin';
import { useSelectorShared } from '~shared/store';
import { Breadcrumbs } from '~web/components/Breadcrumbs';
import { ContentWrapper, Main, PageBackground, Sidebar } from '~web/components/Page';

export const TransferPrescriptions = () => {
  const { trackPageView } = useAnalytics();
  const showProgynySelfServiceForUser = useSelectorShared(getShowProgynySelfServiceForUser);

  useEffect(() => {
    trackPageView({
      event: EVENTS.TRANSFER_PRESCRIPTION_VIEWED,
      params: {
        origin: 'onboarding',
        is_progyny_rx_view: showProgynySelfServiceForUser,
        value_prop_variation: 'transfer-today',
      },
    });
  }, [showProgynySelfServiceForUser, trackPageView]);

  const breadcrumbs = [
    {
      text: 'Account',
      to: '/me',
    },
    {
      text: `Send prescriptions to ${getCompanyName()}`,
      to: '/me/send-prescription-options',
    },
    {
      text: 'Transfer Prescriptions',
    },
  ];

  return (
    <PageBackground>
      <ContentWrapper>
        <Column>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <TransferHeader />
        </Column>
        <Main>
          <Card>
            <LgPadding>
              <TransferForm origin={ORIGIN_NAMES.TRANSFER} />
            </LgPadding>
          </Card>
        </Main>
        <Sidebar>&nbsp;</Sidebar>
      </ContentWrapper>
    </PageBackground>
  );
};
